import React from 'react'
import './GradientUnderline.scss'

const GradientUnderline = () => {
  return (
    <div id='gradient-underline'>
      <div className='bar'></div>
      <div className='overlay'></div>
    </div>
  )
}

export default GradientUnderline
